<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/settings/platforms'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >apps</mat-icon>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          @if (!id) {
            <div class="h2">
              {{'platform.newPlatform' | translate}}
            </div>
          }
          @if (id) {
            <div class="h2">
              {{'platform.editPlatform' | translate}}
            </div>
          }
          <div class="subtitle secondary-text">
            <span>{{'platform.platformDetail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <button mat-raised-button
        class="save-product-button mat-white-bg mt-16 mt-sm-0"
        [disabled]="formGroup && formGroup.invalid" (click)="addPlatform(true)">
        @if (!id) {
          <span>{{'main.add' | translate}}</span>
        }
        @if (id) {
          <span>{{'main.update' | translate}}</span>
        }
      </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <form [formGroup]="formGroup">
          <mat-checkbox formControlName="status"
            [labelPosition]="'after'">
            {{'platform.active' | translate}}
          </mat-checkbox>
          <div class="color">
            {{'color' | translate}}
            <fuse-material-color-picker [(selectedBg)]="chosenColor"
              (onValueChange)="onSettingsChange($event)">
            </fuse-material-color-picker>
          </div>
          <mat-form-field>
            <input matInput placeholder="{{'platform.title' | translate}}" formControlName="title">
          </mat-form-field>
          <mat-form-field>
            <textarea matInput placeholder="{{'platform.description' | translate}}" formControlName="description"
            cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{'platform.infoUrl' | translate}}" formControlName="infoUrl">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="{{'platform.platformUrl' | translate}}" formControlName="platformUrl">
          </mat-form-field>
        </form>
      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>
